import classNames from 'classnames'
import { ChangeEvent, FC, memo } from 'react'
import styles from 'styles/components/form.module.scss'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'

interface Props {
  dataCy?: string
  disabled?: boolean
  fontSize?: number
  id: string
  isChecked: boolean
  label: string
  handleCheckbox?: (id: string) => void
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  size?: 'medium' | 'large'
}

const Checkbox: FC<Props> = memo((props) => {
  const { dataCy, disabled, fontSize, id, isChecked, label, handleCheckbox, onChange, size } = props

  return (
    <label className={styles.checkbox} htmlFor={id} style={disabled ? { cursor: 'unset' } : {}}>
      <input
        className={styles.checkbox__input}
        checked={isChecked}
        disabled={disabled}
        id={id}
        onClick={() => handleCheckbox?.(id)}
        onChange={(e) => onChange?.(e)}
        type="checkbox"
        data-cy={`checkbox-${dataCy}`}
      />
      <span
        className={classNames({
          [styles.checkbox__dummy]: size !== 'large',
          [styles.checkbox__dummy_large]: size === 'large',
        })}
        onKeyPress={(e: React.KeyboardEvent) => {
          // EnterキーかSpaceキーでもチェックの切り替えを行う
          if (e.key === 'Enter' || e.key === ' ') {
            handleCheckbox ? handleCheckbox(id) : null
          }
        }}
        tabIndex={0}
        data-cy={`checkbox-span-${dataCy}`}
      />
      <span className={styles.checkbox__label} style={fontSize ? { fontSize: fontSize } : {}}>
        {HTMLReactParser(returnCodeToBr(label))}
      </span>
    </label>
  )
})

export default Checkbox
